import { render, staticRenderFns } from "./EditNewsPage.vue?vue&type=template&id=23710160&scoped=true&"
import script from "./EditNewsPage.vue?vue&type=script&lang=js&"
export * from "./EditNewsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23710160",
  null
  
)

export default component.exports